import { useState, useEffect, useLayoutEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { GridColDef, GridRowParams, GridSelectionModel, MuiEvent } from '@mui/x-data-grid';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";
import { useForm, Resolver, Controller, SubmitHandler } from "react-hook-form";
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { ICrew } from "../interfaces/ICrew";
import { IUser } from "../interfaces/IUser";
import { ITray } from "../interfaces/ITray";
import { IApplication } from "../interfaces/IApplication";
import { setPageTitle } from "../slices/applicationSlice";
import { useAppDispatch, useAppSelector } from "../hooks";
import SaveIcon from '@mui/icons-material/Save'
import { IBay } from "../interfaces/IBay";
import { IBench } from "../interfaces/IBench";
import { IGreenhouse, IGreenhouses } from "../interfaces/IGreenhouse";
import { IZone } from "../interfaces/IZone";
import ListItemText from '@mui/material/ListItemText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from "@mui/material/OutlinedInput";
import { setSelectionValues } from "../slices/selectionSlice";
import PatchingSearchChips from "../components/Patching/PatchingSearchChips";
import { IPatchingSearchChips } from "../interfaces/Patching/IPatchingSearchChips";
import { useNavigate } from "react-router-dom";
import ActionButton from "../components/ActionButton";
import ActionMenu from "../components/ActionMenu";

const ITEM_HEIGHT = 42;
const ITEM_PADDING_TOP = 0;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
];

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

type Anchor = 'top' | 'left' | 'bottom' | 'right';

interface IFormInput {
  Name: string
  Type: string
  Crew: ICrew,
  User: IUser
}

const resolver: Resolver<IFormInput> = async (values) => {
  return {
    values: values.Name ? values : {},
    errors: !values.Name
      ? {
        Name: {
          type: 'required',
          message: 'This is required.',
        },
      }
      : {},
  };
};

const steps = ['Patching List Management', 'Select Trays'];

export default function PatchingList() {

  const dispatch = useAppDispatch();
  const [rows, setRows] = useState<ITray[]>([]);
  const [selectedCrew, setSelectedCrew] = useState<ICrew>();
  const [selectedUsers, setSelectedUsers] = useState<IUser[]>([]);
  const [crews, setCrews] = useState<ICrew[]>([]);
  const [users, setUsers] = useState<IUser[]>([]);
  const [currentUser, setCurrentUser] = useState<IUser>();
  const [trays, setTrays] = useState<IGreenhouse[] | IBay[] | IZone[] | IBench[] | ITray[]>([]);
  const [selectedTrays, setSelectedTrays] = useState<ITray[]>([]);
  const [selectedPatchWeeks, setSelectedPatchWeeks] = useState<IPatchingWeek[]>([]);
  const [greenHouses, setGreenHouses] = React.useState<IGreenhouses>([]);
  const [currentGreenhouse, setCurrentGreenhouse] = React.useState<IGreenhouse>();
  const [bays, setBays] = React.useState<IBay[]>([]);
  const [currentBay, setCurrentBay] = React.useState<IBay>();
  const [zones, setZones] = React.useState<IZone[]>([]);
  const [currentZone, setCurrentZone] = React.useState<IZone>();
  const [benches, setBenches] = React.useState<IBench[]>([]);
  const [currentBench, setCurrentBench] = React.useState<IBench>();
  const [searchInformation, setSearchInformation] = React.useState<IPatchingSearchChips>({ year: 2023, weeks: [], generation: '', traySize: '' });

  const [species, setSpecies] = useState<Array<string>>([]);
  const [selectedSpecies, setSelectedSpecies] = useState<string>("");
  const [varieties, setVarieties] = useState<Array<string>>([]);
  const [selectedVariety, setSelectedVariety] = useState<string>("");
  const [colors, setColors] = useState<Array<string>>([]);
  const [selectedColor, setSelectedColor] = useState<string>("");
  const [classes, setClasses] = useState<Array<string>>([]);
  const [selectedClass, setSelectedClass] = useState<string>("");

  function PatchingClicked(_event: React.MouseEvent<HTMLElement>): void {
    
    setOpen(true);
  }

  const [open, setOpen] = useState(false);

  function handleClose() {
    setOpen(!open);
  }

  const buttons = [
    <ActionButton action={PatchingClicked} buttonLabel="New Patching List" />,
   
  ];


  useEffect(() => {

    if (selectedSpecies) {
      if (selectedVariety) {
        var splitDescriptions = trays.map((x) => {
          if (x.description.includes(selectedSpecies) && x.description.includes(selectedVariety)) {
            return x.description.split(' ');
          } else {
            return "";
          }
        });
        var colors = new Set(splitDescriptions.map(x => x[3]));
        setColors(Array.from(colors));
      } else {
        var splitDescriptions = trays.map((x) => {
          if (x.description.includes(selectedSpecies)) {
            return x.description.split(' ');
          } else {
            return "";
          }
        });
        var varieties = new Set(splitDescriptions.map(x => x[2]));
        setVarieties(Array.from(varieties))
      }
    } else {
      setVarieties([]);
      setColors([]);
    }
  }, [selectedSpecies, selectedVariety, selectedColor, selectedClass])

  const patchingListTypes = ["Gen 1", "Gen 2", "Manual", "Blow-Out"];

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  interface IPatchingWeek {
    id: number,
    name: string
  }

  const GetPatchingLists = () => {
    console.log("GET PATCHING LISTS SEARCH INFO", searchInformation);
    if (searchInformation) {
      axios
        .post(`${process.env.REACT_APP_ENDPOINT}/api/PatchingLists/search`, searchInformation)
        .then(res => {
          console.log("RESPONSE", res);
          setRows(res.data);
        })
    }
  }

  useEffect(() => {

    let appState: IApplication = {
      pageTitle: "Patching Lists",
      backgroundPath: "/assets/images/patchingbg.jpg"
    }
    dispatch(setPageTitle(appState));

    axios
      .get(`${process.env.REACT_APP_ENDPOINT}/api/Crews`)
      .then(res => {
        setCrews(res.data);
      })

    axios
      .get(`${process.env.REACT_APP_ENDPOINT}/api/Users`)
      .then(res => {
        setUsers(res.data);
      })

    axios
      .get(`${process.env.REACT_APP_ENDPOINT}/api/Greenhouses`)
      .then(res => {
        console.log("GREENHOUSES", res.data);
        setGreenHouses(res.data);
      })

  }, []);

  const GetTraysByLocation = (greenhouseID: number, bayId: number = 0, zoneId: number = 0, benchId: number = 0) => {
    axios
      .get(`${process.env.REACT_APP_ENDPOINT}/api/Trays/SearchTrays/${greenhouseID}/${bayId}/${zoneId}/${benchId}`)
      .then(res => {
        console.log("RESPONSE DATA", res);
        if (res.status == 200) {
          setTrays(res.data);
        } else {
          setTrays([]);
        }
      })
  }

  useLayoutEffect(() => {
    if (currentGreenhouse) {
      if (currentBay) {
        if (currentZone) {
          if (currentBench) {
            GetTraysByLocation(currentGreenhouse.id, currentBay.id, currentZone.id, currentBench.id);
          } else {
            //Load Benches and zone trays
            GetTraysByLocation(currentGreenhouse.id, currentBay.id, currentZone.id);
            setBenches(currentZone.benches);
          }
        } else {
          //Load Zones and bay trays
          GetTraysByLocation(currentGreenhouse.id, currentBay.id);
          setZones(currentBay.zones);
        }
      } else {
        //Load Bays and Greenhouse Trays
        GetTraysByLocation(currentGreenhouse.id);
        setBays(currentGreenhouse.bays);
      }
    } else {
      setBays([]);
      setCurrentBay(undefined);
      setZones([]);
      setCurrentZone(undefined);
      setBenches([]);
      setCurrentBench(undefined);
      setTrays([]);
    }

  }, [currentGreenhouse, currentBay, currentZone, currentBench])

  useLayoutEffect(() => {
    var splitDescriptions = trays.map((x) => {
      return x.description.split(' ');
    });
    var species = new Set(splitDescriptions.map(x => x[1]));

    setSpecies(Array.from(species));
  }, [trays])

  useEffect(() => {
    console.log("IN HERE EVERYONE");
    GetPatchingLists();
  }, [searchInformation])

  useEffect(() => {
    // console.log("Selected Crew Changed");
    // if (selectedCrew) {
    //   var users = selectedCrew.userCrews.map(obj => {
    //     return obj.user!
    //   });
    //   if (users) {
    //     setSelectedUsers(users);
    //   }
    // }
  }, [selectedCrew])

  useEffect(() => {
    console.log("IN CURRENT USER");
    if (currentUser != undefined) {
      if (selectedUsers) {
        let users = [...selectedUsers, currentUser]
        console.log("USERS", users);
        setSelectedUsers(users);
      }
    }
    setCurrentUser(undefined);
  }, [currentUser])


  const { register, handleSubmit, control, formState: { errors } } = useForm<IFormInput>({ resolver });

  const onSubmit: SubmitHandler<IFormInput> = data => {
    console.log("ON SUBMIT DATA", data);
    console.log("SELECTION", fetchedSelection);
    axios.post(`${process.env.REACT_APP_ENDPOINT}/api/PatchingLists`, {
      name: data.Name, generation: data.Type, crewId: data.Crew.id, trayIds: fetchedSelection.selection
    }).then((data) => {
      if (data.status === 200) {
        // setOpen(false);
      };
    });
  };

  const [helpOpen, setHelpOpen] = React.useState(false);
  const [nextOpen, setNextOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };

  const handleHelpClose = () => {
    setHelpOpen(false);
  };

  const handleNextOpen = () => {
    setNextOpen(true);
  };

  const handleNextClose = () => {
    setNextOpen(false);
  };


 



  const columns: GridColDef[] = [
    //{ field: 'id', headerName: 'ID', width: 130 },
    { field: 'name', headerName: 'Name', width: 250 },
    { field: 'status', headerName: 'Status', width: 75 },
    { field: 'patchWeek', headerName: 'PT Week', width: 75, },
    { field: 'patchYear', headerName: 'PT Year', width: 75, },
    { field: 'projectedCompletion', headerName: 'Projected Completion', width: 160, },
    { field: 'actualCompletion', headerName: 'Actual Completion', width: 150, },
    { field: 'trayType', headerName: 'Tray Type', width: 90, },
    { field: 'generation', headerName: 'Generation', width: 110, },
    { field: 'crew.name', headerName: 'Assigned Crews', width: 150, valueGetter: (params) => { return params.row.crew != null ? params.row.crew.name : "" } },
  ];

  interface IPatchingRow {
    id: number,
    name: string,
    status: string,
    patchweek: number,
    generation: string
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  function valuetext(value: number) {
    return `${value}°C`;
  }

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#89B219',
      },
    },
  });

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const handleDelete = (props: IUser) => {
    var users = selectedUsers.filter(obj => {
      return obj.id != props.id
    });
    setSelectedUsers(users);
  };

  const navigate = useNavigate();

  const handleDoubleClick = (x: GridRowParams<any>, y: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>) => {
    navigate('/patching/patching-combifix', {state: {patchingList: x.row}})
  }

  const handlePatchingDelete = (props: IPatchingWeek) => {
    var weeks = selectedPatchWeeks.filter(obj => {
      return obj.id != props.id
    });
    setSelectedPatchWeeks(weeks);
  };

  function LoadTrays() {
    axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Trays`).then(res => {
      setTrays(res.data);
    })
  }

  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());

  const isStepOptional = (step: number) => {
    return false;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const trayColumns: GridColDef[] = [
    //{ field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Name', width: 230 },
    { field: 'description', headerName: 'Description', width: 300 },
    { field: 'species', headerName: 'Species', width: 200 },
    { field: 'variety', headerName: 'Variety', width: 250 },
    { field: 'color', headerName: 'Color', width: 200 },
  ];

  const fetchedSelection = useAppSelector((state) => state.selection);



  const handleSearchChips = (searchInformation: IPatchingSearchChips) => {
    console.log("Testing", searchInformation)
    setSearchInformation(searchInformation);
    // GetPatchingLists();
  }

  const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);


  const [personName, setPersonName] = React.useState<string[]>([]);

  const handleMemberChange = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  function ClearSelection() {
    setCurrentGreenhouse(undefined);
    setCurrentBench(undefined);
    setSelectedSpecies("");
  }


  return (
    <div>
     <ActionMenu buttons={buttons} />
      <Grid container spacing={0} bgcolor="#101010">
        <ThemeProvider theme={darkTheme}>
          <PatchingSearchChips handleSearch={handleSearchChips}></PatchingSearchChips>
        </ThemeProvider>

        <Grid item xs={12}>
          <Item>
            <div style={{ height: 'calc(100vh - 156px)', width: '100%' }}>
              <StripedDataGrid
                rows={rows}
                columns={columns}
                pageSize={20}
                rowsPerPageOptions={[20]}
                onRowDoubleClick={(x, y) => handleDoubleClick(x, y)}
                sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }
              />
            </div>
          </Item>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={false}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Add New Patching List
            </Typography>
          </Toolbar>
        </AppBar>
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <DialogContent sx={{ padding: '10px' }}>
            <Grid container>
              <Grid item xs={12} marginTop={1}><Typography variant="h6" fontWeight={500} sx={{ pl: 1 }}>New Patching List Info</Typography></Grid>
              <Grid item xs={3}>
                <Item>
                  <TextField
                    required
                    variant="outlined"
                    fullWidth
                    id="patchinglistname"
                    label="Patching List Name"
                    {...register("Name")} />
                </Item>
              </Grid>
              <Grid item xs={3}>
                <Item>
                  <Controller
                    control={control}
                    name="Type"
                    // defaultValue={ patchingListTypes[0].label }
                    render={({ field: { ref, onChange, ...field } }) => (
                      <Autocomplete
                        value={field.value}
                        options={patchingListTypes}
                        getOptionLabel={(option) => option}
                        onChange={(_, data) => {
                          return onChange(data);
                        }}
                        // defaultValue={[patchingListTypes[0]]}
                        renderInput={(params) => (
                          <TextField {...params} {...field} fullWidth inputRef={ref} variant="outlined" label="Select a Type"></TextField>
                        )}
                      />
                    )}
                  />
                </Item>
              </Grid>
              <Grid item xs={3}>
                <Item>
                  <Controller
                    control={control}
                    name="Crew"
                    render={({ field: { ref, onChange, ...field } }) => (
                      <Autocomplete
                        value={selectedCrew}
                        options={crews}
                        getOptionLabel={(option) => `${option.id}: ${option.name}`}
                        onChange={(_, data) => {
                          setSelectedCrew(data!);
                          return onChange(data);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} {...field} inputRef={ref} variant="outlined" label="Select a Crew"></TextField>
                        )}
                      />
                    )}
                  />
                </Item>
              </Grid>
              <Grid item xs={3}>
                <Item>
                  <FormControl sx={{ width: '100%' }}>
                    <InputLabel id="demo-multiple-checkbox-label">Add Employees</InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      multiple
                      value={personName}
                      onChange={handleMemberChange}
                      input={<OutlinedInput />}
                      renderValue={(selected) => selected.join(', ')}
                      MenuProps={MenuProps}
                      sx={{ textAlign: "left" }}
                    >
                      {names.map((name) => (
                        <MenuItem key={name} value={name}>
                          <Checkbox checked={personName.indexOf(name) > -1} />
                          <ListItemText primary={name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Item>
              </Grid>
              <Grid item xs={12} sx={{ marginBottom: 1, marginTop: 0 }}>
                <Item sx={{ bgcolor: 'transparent' }}>
                  <Stack direction="row" spacing={1}>
                    {selectedUsers?.map(obj => {
                      return <Chip key={obj.id} label={`${obj.firstName} ${obj.lastName}`} color="primary" onDelete={() => handleDelete(obj)} />
                    })}
                  </Stack>
                </Item>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid item xs={12} marginTop={0}>
                  <Typography variant="h5" fontWeight={500} sx={{ pl: 1 }}>Available Trays</Typography>
                </Grid>

                <Grid container xs={12}>
                  <Grid item xs={2}>
                    <Item sx={{ bgcolor: 'transparent' }}>
                      <Autocomplete
                        value={currentGreenhouse}
                        options={greenHouses}
                        getOptionLabel={(option) => option.name}
                        onChange={(_, data) => {
                          setCurrentGreenhouse(data!);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth variant="outlined" label="Greenhouses"></TextField>
                        )}
                      />
                    </Item>
                  </Grid>
                  <Grid item xs={2}  >
                    <Item sx={{ bgcolor: 'transparent' }}>
                      <Autocomplete
                        value={currentBay}
                        options={bays}
                        getOptionLabel={(option) => option.name}
                        onChange={(_, data) => {
                          setCurrentBay(data!)
                          setZones(data?.zones!)
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth variant="outlined" label="Bays"></TextField>
                        )}
                      />
                    </Item>
                  </Grid>
                  <Grid item xs={2}>
                    <Item sx={{ bgcolor: 'transparent' }}>
                      <Autocomplete
                        value={currentZone}
                        options={zones}
                        getOptionLabel={(option) => option.name}
                        onChange={(_, data) => {
                          setCurrentZone(data!);
                          setBenches(data?.benches!)
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth variant="outlined" label="Zones"></TextField>
                        )}
                      />
                    </Item>
                  </Grid>
                  <Grid item xs={2}>
                    <Item sx={{ bgcolor: 'transparent' }}>
                      <Autocomplete
                        value={currentBench}
                        options={benches}
                        getOptionLabel={(option) => option.name}
                        onChange={(_, data) => {
                          setCurrentBench(data!);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth variant="outlined" label="Benches"></TextField>
                        )}
                      />
                    </Item>
                  </Grid>
                  <Grid item xs={2}>
                    <Item sx={{ bgcolor: 'transparent' }}>
                      <Button onClick={() => { ClearSelection() }} color="primary" variant='contained' fullWidth sx={{ marginTop: 1 }}>CLEAR SELECTION</Button>
                    </Item>
                  </Grid>
                </Grid>
                <Grid container xs={12}>
                  <Grid item xs={2}>
                    <Item sx={{ bgcolor: 'transparent' }}>
                      <Autocomplete
                        value={selectedSpecies}
                        options={species}
                        getOptionLabel={(option) => option}
                        onChange={(_, data) => {
                          setSelectedSpecies(data!);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth variant="outlined" label="Species"></TextField>
                        )}
                      />
                    </Item>
                  </Grid>
                  <Grid item xs={2}  >
                    <Item sx={{ bgcolor: 'transparent' }}>
                      <Autocomplete
                        value={selectedVariety}
                        options={varieties}
                        getOptionLabel={(option) => option}
                        onChange={(_, data) => {
                          setSelectedVariety(data!)
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth variant="outlined" label="Variety"></TextField>
                        )}
                      />
                    </Item>
                  </Grid>
                  <Grid item xs={2}>
                    <Item sx={{ bgcolor: 'transparent' }}>
                      <Autocomplete
                        value={selectedColor}
                        options={colors}
                        getOptionLabel={(option) => option}
                        onChange={(_, data) => {
                          setSelectedColor(data!);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth variant="outlined" label="Color"></TextField>
                        )}
                      />
                    </Item>
                  </Grid>
                  <Grid item xs={2}>
                    <Item sx={{ bgcolor: 'transparent' }}>
                      <Autocomplete
                        value={selectedClass}
                        options={classes}
                        getOptionLabel={(option) => option}
                        onChange={(_, data) => {
                          setSelectedClass(data!);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth variant="outlined" label="Class"></TextField>
                        )}
                      />
                    </Item>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Item>
                  <div style={{ height: 'calc(90vh - 500px)', width: '100%' }}>
                    <StripedDataGrid
                      rows={trays}
                      columns={trayColumns}
                      pageSize={15}
                      rowsPerPageOptions={[15]}
                      checkboxSelection
                      onSelectionModelChange={(newSelectionModel) => {
                        dispatch(setSelectionValues({ selection: newSelectionModel }))
                      }}
                      keepNonExistentRowsSelected
                      selectionModel={fetchedSelection.selection}
                      sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                      }
                    />
                  </div>
                </Item>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ m: 0 }}>
            <Button
              endIcon={<SaveIcon />}
              size="large"
              variant="contained"
              color="success"
              onClick={handleNextOpen}>Create New Patching List
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </div >
  );
}